import styled, { css } from 'styled-components';

import { project_colors } from '../../../constants';
import {
  ColumnBlock,
  CommonClickAction,
  FlexParentBlock,
  SpaceBetweenBlock,
  VerticalCenterBlock,
  VerticalCenterLeftBlock,
  VerticalHorizontalCenterBlock,
  VerticalHorizontalCenterColumnBlock
} from '../../../styled';

type PaginationProps = {
  direction: string;
  disabled: boolean;
};

const OverflowTextStyles = css`
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;

const NavCellAction = css`
  transform: rotate(180deg);
`;

export const DangerTitle = styled.p`
  font-size: 11px;
  line-height: 16px;
  color: ${(props) => props.theme.colors.danger};
  margin: 0;
  margin-right: 4px;
  margin-left: 10px;
`;

export const UserInfoWrapper = styled.div`
  overflow: hidden;
  padding-right: 20px;
`;

export const UsernameLabel = styled.h3`
  ${(props) => props.theme.typography.subHeader3};
  margin-bottom: 4px;
  ${OverflowTextStyles};
`;
export const UserIdLabel = styled.p`
  ${(props) => props.theme.typography.descriptionCompact};
  color: ${(props) => props.theme.colors.muted};
  ${OverflowTextStyles};
`;

export const GroupLabel = styled.h3`
  ${(props) => props.theme.typography.subHeader3};
`;

export const SelectValue = styled.div`
  color: ${(props) => props.theme.colors.text};
`;

export const ContactWrapper = styled(ColumnBlock)`
  gap: 4px;
`;

export const ContactInfo = styled.div`
  ${(props) => props.theme.typography.descriptionCompact}
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const NotConfirmStatusCircle = styled.div`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: ${(props) => props.theme.colors.info};
  box-shadow: 0 2px 4px rgba(255, 129, 17, 0.2);
  margin-left: -15px;
  margin-right: 10px;
`;

export const UserMoreButton = styled(VerticalCenterBlock)`
  ${CommonClickAction};
  color: ${project_colors.NEUTRAL_LIGHT};
  padding-top: 5px;
  :hover {
    color: ${(props) => props.theme.colors.text};
  }
`;

export const NavCellWrapper = styled(VerticalHorizontalCenterBlock)`
  width: 100%;
  height: 100%;
  cursor: pointer;
`;

export const NavCellIcon = styled.div<{ collapsed?: boolean }>`
  transition: 0.1s ease-out;
  svg {
    ${(props) => props.collapsed && NavCellAction};
  }
`;

export const ManageUserWrapper = styled(VerticalCenterBlock)`
  justify-content: flex-end;
  gap: 10px;
  height: 20px;
  width: 100%;
  padding-right: 24px;
`;

// ban info row styles

export const BanInfoRow = styled.div`
  display: flex;
  width: 100%;
  padding: 16px 30px 16px 0;
`;

export const BanInfoIndent = styled.div`
  width: 5%;
`;

export const BanInfoWrapper = styled.div`
  width: 95%;
`;

export const BanInfoTitle = styled.h3`
  color: ${(props) => props.theme.colors.muted};
  ${(props) => props.theme.typography.label}
  margin-bottom: 12px;
`;

export const BanInfoSubtitle = styled.p`
  color: ${(props) => props.theme.colors.muted};
  ${(props) => props.theme.typography.description}
  margin-bottom: 8px;
`;

export const BanInfoDescription = styled.p`
  ${(props) => props.theme.typography.description}
  margin-bottom: 8px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

export const BanTitlesBlock = styled.div`
  margin-right: 50px;
  flex-shrink: 0;
`;

// filter table styles

export const FilterTableWrapper = styled(VerticalCenterLeftBlock)`
  margin-bottom: 30px;
  flex-wrap: wrap;
  row-gap: 10px;
`;

export const FilterUserBlock = styled.div`
  width: auto;
  margin-right: 8px;
`;

export const UserStatusBlock = styled.div`
  min-width: 120px;
  margin-right: 8px;
`;

export const UserSettingsBlock = styled(SpaceBetweenBlock)`
  margin-bottom: 14px;
`;

export const UsersNumber = styled.h4`
  ${(props) => props.theme.typography.subHeader3};
`;

export const NoDataContentBox = styled(VerticalHorizontalCenterColumnBlock)`
  min-height: 300px;
`;

export const NoDataSubtitle = styled.p`
  ${(props) => props.theme.typography.bodyCompact};
  color: ${(props) => props.theme.colors.muted};
`;

export const HorizontalSeparator = styled.div`
  margin: 0 12px;
  width: 1px;
  height: inherit;
  background-color: ${(props) => props.theme.colors.muted};
`;

export const StyledFlexParentBlock = styled(FlexParentBlock)`
  button {
    flex-grow: 1;
    flex-shrink: 1;
  }
`;

export const PaginationWrapper = styled(VerticalHorizontalCenterBlock)`
  margin-top: 24px;
`;

export const UserSettingsWrapper = styled.div``;

export const ListWrapper = styled(VerticalHorizontalCenterBlock)`
  position: relative;
`;

export const StatusUserSelect = styled.div`
  display: flex;
  color: ${(props) => props.theme.colors.text};
`;

export const PaginationArrowButtonDiv = styled.div`
  margin-top: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ArrowButton = styled.button<PaginationProps>`
  ${(props) => props.disabled && 'pointer-events: none'};
  background-color: ${(props) => (props.disabled ? '#f7faff' : '#ffffff')};
  color: ${(props) => (props.disabled ? '#a0abb8' : '#747e8a')};
  cursor: ${(props) => (props.disabled ? 'none' : 'pointer')};
  border-radius: ${(props) => (props.direction === 'left' ? '4px 0 0 4px' : '0 4px 4px 0')};
  font-size: 13px;
  line-height: 16px;
  font-weight: 500;
  border: 1px solid #c5d0db;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-right: -1px;
  width: 40px;
  height: 34px;
`;
